import './dossier.css';
import './dossier-titre.css';
import './dossier-cartillu.css';
import './dossier-somation.css';
import './dossier-historique.css';
import './dossier-description.css';
import './dossier-interetProtection.css';
import './dossier-illustrations.css';
import './dossier-documentation.css';
import './dossier-donnees-complementaires.css';
import './dossier-lien-inter.css';
import './dossier-actions.css';
import './dossier-acces.css';
import './lien-dossier.css';
import '../references-documentaires/references-documentaires.css';
import '../partenaires/partenaires.css';
import '../common/tablerixme.css';
import '../dossiers-carousel/dossiers-carousel.css';
import './text-rich.css';
import '../utils/utils.css';
import '../carto/carto.css';
import '../carto/ol-override.css';
import '../modal/modal.css';
import '../../node_modules/ol/ol.css';

import './text-rich.js';
import './dossier-illustrations.js';
import '../references-documentaires/references-documentaires.js';
import {
  clampLines,
  avoidUpscalingImage,
  waitForImageLoaded,
  limitListElements,
  getShowAllElement,
  checkImageInError,
} from '../utils/utils.js';
import { initModal } from '../modal/modal.js';
import { initDossiersCarousel } from '../dossiers-carousel/dossiers-carousel.js';
import { initCarto } from './dossier-carto.js';
import './dossier-somation.js';
import {
  manageButton,
  manageSelectionLinkInHeader,
} from '../selection/utils.js';

initDossiersCarousel(document.querySelector('.dossier .dossiers-carousel'));

const { openClampLines: openClampLinesContenu } = clampLines(
  document.querySelector('.dossier-somation-right-contenu .clampLines'),
  30,
);

document
  .querySelectorAll(
    `
    .dossier-cartillu-illu-copyrights .value,
    .dossier-localisation .value,
    .dossier-designation-element .value
  `,
  )
  .forEach((valueElement) => {
    const showAllElement = getShowAllElement(valueElement);
    // Si la valeur est elle-même une liste, clampLines ne peut pas fonctionner directement
    // On doit d'abord limiter le nombre de <li> affichés à 5 puis enfin utiliser clampLines pour limiter la taille des lignes <li>
    if (valueElement.matches('ul')) {
      limitListElements(valueElement, 5, showAllElement);

      valueElement
        .querySelectorAll('li')
        .forEach((subValueElement) =>
          clampLines(subValueElement, 1, false, showAllElement),
        );
    } else {
      clampLines(valueElement, 5, false);
    }
  });

document
  .querySelectorAll('.tablerixme-content .clampLines')
  .forEach((tablerixme) => {
    clampLines(tablerixme, 20);
  });

document
  .querySelectorAll(`.dossier-donnees-complementaires .clampedTable`)
  .forEach((valueElement) => {
    const showAllElement = getShowAllElement(valueElement);
    limitListElements(valueElement, 5, showAllElement);
  });

// Ajoute un scroll quand on clic sur un élément du sommaire
document
  .getElementById('sommaireList')
  ?.querySelectorAll('.presentationLink')
  .forEach(function (element) {
    element.addEventListener('click', function ({ target }) {
      const { presentationIndex } = target.dataset;
      const titre = document.getElementById(
        `presentation-${presentationIndex}`,
      );

      openClampLinesContenu?.();

      const sommaireBtnWrapper = document.querySelector(
        '.sommaire-bouton-wrapper',
      );
      window.scroll({
        top: titre.offsetTop - (sommaireBtnWrapper?.offsetHeight ?? 0) / 2,
        behavior: 'smooth',
      });
    });
  });

const modalCiter = document.getElementById('modalCiter');
const btnModalCiter = document.getElementById('btnModalCiter');

initModal(modalCiter, btnModalCiter);

const messageCitationCopier = document.getElementById('messageCitationCopier');

document
  .getElementById('btnModalCopy')
  ?.addEventListener('click', function citationDossier() {
    window
      .getSelection()
      .selectAllChildren(document.getElementById('citationDossier'));
    document.execCommand('copy');

    messageCitationCopier.style.display = 'block';
    setTimeout(function () {
      messageCitationCopier.style.display = 'none';
    }, 2500);
  });

// les modals des annexes
document.querySelectorAll('[data-modal-id]').forEach((btnModal) => {
  const { modalId } = btnModal.dataset;
  const modal = document.getElementById(modalId);
  initModal(modal, btnModal);
});

const selectionButton = document.querySelector('[data-action="selection:add"]');
if (selectionButton) {
  manageButton(selectionButton);
}

// La hauteur de la carto ne s'initialise pas correctement sous Firefox :
// La taille du container de la carto n'est pas correcte au moment de l'initialisation
// (possiblement parce que l'image n'est pas encore chargée)
// Attendons le chargement de l'image pour initialiser la carto
const mainImageElement = document.querySelector('.dossier-cartillu-illu img');
const cartilluContainer = document.querySelector('.dossier-cartillu');
if (mainImageElement) {
  const manageCarto = () => {
    const { updateSize: updateCartoSize } = initCarto();

    function updateCartilluSize() {
      // On s'assure que le bloc de texte en-dessous a la même taille que l'image
      // On modifie les règles de gestion dela grille CSS au lieu de modifier directement la taille
      // du bloc du texte en dessous de l'image pour ne pas casser l'affichage en mode mobile
      const width = [
        ...document.querySelectorAll(
          '.dossier-cartillu-illu img, .dossier-cartillu-illu .image-indispo',
        ),
      ]
        .map((element) => element.offsetWidth)
        .reduce((size1, size2) => Math.max(size1, size2), 0);
      cartilluContainer.style.gridTemplateColumns = `fit-content(${width}px) auto`;
      updateCartoSize();
    }

    checkImageInError(mainImageElement, '.image-container');

    updateCartilluSize();

    avoidUpscalingImage(mainImageElement, () => updateCartilluSize());
  };
  waitForImageLoaded(mainImageElement, manageCarto, manageCarto);
} else {
  initCarto();
}

document
  .querySelectorAll(
    '.dossier-lien-inter .lien-dossier-vignette, .dossier-lien-inter .dossier-lien-inter-edifice-vignette',
  )
  .forEach((vignette) =>
    checkImageInError(vignette, '.lien-dossier, .dossier-lien-inter-content'),
  );

manageSelectionLinkInHeader();

const imageElements = document.querySelectorAll(
  '.dossier-illustrations-apercu img',
);
imageElements.forEach((imageElement) => avoidUpscalingImage(imageElement));
